import {
  integrationOrderOverlayPaths,
  projectPurchasedAssetOverlayPaths,
} from "@features/assets-feature/routing/assetRouteSegments";

/** Project detail route up to `:projectId`; `App.tsx` adds the tab and overlay splat. */
export const IT_PROJECT_DETAIL_ROUTE = "/:prefix?/projects/:projectId";

/**
 * Routed overlay segments for IT projects. Detail overlays nest under the active tab, because
 * `ItProjectDetailFeature` redirects a missing tab to the orders tab.
 */
export const IT_PROJECT_SEGMENTS = {
  create: "new",
  edit: "edit",
  linkOrders: "link-orders",
  uploadAttachment: "upload-attachment",
} as const;

/** Detail tabs that host overlays; ids match `IT_PROJECTS_TAB_CONFIGS`. */
export const IT_PROJECT_OVERLAY_TAB_IDS = {
  orders: "orders",
  integrationOrders: "integration-orders",
  assets: "assets",
  attachments: "attachments",
} as const;

/** Edit drawer tab slugs, from `toRouteSlug` of the `IT_PROJECT_DRAWER_TABS` values. */
export const IT_PROJECT_EDIT_TABS = ["details", "linked-items"] as const;
export type ItProjectEditTab = (typeof IT_PROJECT_EDIT_TABS)[number];

/** Edit drawer opened from a `/projects` list row; `App.tsx` serves it from a static route. */
export const IT_PROJECT_LIST_EDIT_PATH = `${IT_PROJECT_SEGMENTS.edit}/:projectId/:editTab?`;

/** `base` ends at the `:projectId` segment of the project detail route. */
export const itProjectDetailOverlayPaths = (base: string): string[] => {
  const tab = (id: string) => `${base}/${id}`;
  return [
    `${base}/:tabId/${IT_PROJECT_SEGMENTS.edit}/:editTab?`,
    `${tab(IT_PROJECT_OVERLAY_TAB_IDS.orders)}/${IT_PROJECT_SEGMENTS.linkOrders}`,
    `${tab(IT_PROJECT_OVERLAY_TAB_IDS.assets)}/${IT_PROJECT_SEGMENTS.linkOrders}`,
    `${tab(IT_PROJECT_OVERLAY_TAB_IDS.attachments)}/${IT_PROJECT_SEGMENTS.uploadAttachment}`,
    ...projectPurchasedAssetOverlayPaths(
      tab(IT_PROJECT_OVERLAY_TAB_IDS.assets),
    ),
    ...integrationOrderOverlayPaths(
      tab(IT_PROJECT_OVERLAY_TAB_IDS.integrationOrders),
    ),
  ];
};
